import React from 'react';
import ReactDOM from 'react-dom/client';
import './global.css';
import App from './App';
import { ConfigProvider } from './services/ConfigProvider';
import { ErrorBoundary } from './services/tracer';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ConfigProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </ConfigProvider>
  </React.StrictMode>,
);
